import {
  Component,
  forwardRef,
  Injector,
  OnInit,
  AfterContentInit,
} from '@angular/core';
import {
  ControlValueAccessor,
  NG_VALUE_ACCESSOR,
  NgControl,
} from '@angular/forms';

import { FormCommonFunctions2 } from '../form-common-functions';

@Component({
  selector: 'appForm2-list-textarea',
  styleUrls: ['../form.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ListFormTextarea2Component),
      multi: true,
    },
  ],
  template: `
    <div class="p-col-12 p-g-nopad" #container style="position:relative">
      <textarea
        style="flex-grow: 8"
        class="form-control resize-vert"
        [escape]="false"
        tooltipEvent="focus"
        tooltipPosition="bottom"
        [pTooltip]="control.hints || null"
        [rows]="rows || 2"
        [(ngModel)]="value"
        [disabled]="disabled"
        (blur)="onTouched()"
        (input)="pushChanges($event.target.value)"
        [class.form-control-danger]="control.showErrors || ''"
        [attr.id]="htmlAttributes['input']['id']"
        [attr.form-control-name]="control['name']"
        [attr.tabindex]="htmlAttributes['input']['tabIndex']"
        [placeholder]="htmlAttributes['label']['value'] || control.label"
        pInputTextarea
      ></textarea>
      <div *ngIf="control.showErrors" class="vendium-tool-tip">
        <p
          *ngFor="let error of control['mergedErrors']"
          class="form-control-feedback"
        >
          <span><i class="fa fa-times"></i> </span
          ><span [innerHTML]="error"></span>
        </p>
      </div>
    </div>
  `,
})
export class ListFormTextarea2Component
  extends FormCommonFunctions2
  implements ControlValueAccessor, OnInit, AfterContentInit
{
  value: any;
  onChange: (value: any) => void;
  onTouched: () => void;
  disabled: boolean;
  ngControl: NgControl;

  constructor(private inj: Injector) {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
    this.ngControl = this.inj.get(NgControl);
    this.control = this.ngControl;
  }

  ngAfterContentInit() {
    this.control = this.ngControl.control;
  }

  writeValue(value: any): void {
    this.value = value !== undefined ? value : null;
  }

  pushChanges(value: any) {
    this.onChange(value);
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
